import { FileUploadItem } from 'components/FileUpload/FileUploadItem';
import { theme } from 'lib/theme';
import React from 'react';
import { CardRow } from 'components/CardRow';
import { SeparatorHorizontal } from 'components/SeparatorHorizontal';
import { Card } from 'components/Card';
import { pluraliseS } from 'lib/pluralise';

export const TaskAssignedCommentAttachments: React.FC<{
  uploadIds: string[];
  onCancelled: (uploadId: string) => void;
  cancelDisabled?: boolean;
}> = React.memo(
  ({ uploadIds, onCancelled, cancelDisabled }) =>
    !!uploadIds.length && (
      <>
        <SeparatorHorizontal
          style={{
            marginHorizontal: theme.padding,
            marginBottom: theme.padding,
          }}
        />
        <Card
          label={pluraliseS(uploadIds.length, 'Attached File')}
          style={{ marginBottom: theme.padding }}
        >
          {uploadIds.map((uploadId) => (
            <CardRow
              key={uploadId}
              style={{
                backgroundColor: theme.colors.black2,
              }}
            >
              <FileUploadItem
                uploadId={uploadId}
                onCancelled={onCancelled}
                cancelDisabled={cancelDisabled}
                thumbnailStyle={{
                  borderRadius: theme.cardBorderRadius - theme.padding / 4,
                }}
              />
            </CardRow>
          ))}
        </Card>
      </>
    ),
);
